import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { AiSparkleIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { showAcknowledgementModal, MR_ONBOARDING_WIZARD, AI_NOTETAKER_METERED_ACCESS_STARTED } from 'features/meeting_intelligence';
import { TRACKING_EVENT_NAMES, useTrack } from 'hooks/analytics_events';
import { useNotetaker, AddNotetakerButton } from '../header/add_notetaker_button';
const ADD_BUTTON_LOCATION = 'notetaker_banner';
const containerAddNotetakerCss = "c1apmrvn";
const containerCss = "c1kgca6q";
const Container = forwardRef((props, ref) => {
  const {
    addNotetaker,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerAddNotetakerCss]: addNotetaker
  }, props.className)} />;
});
const headerTextCss = "h1v325o4";
const HeaderText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerTextCss, props.className)} />;
});
const bodyTextCss = "b1edfv6u";
const BodyText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(bodyTextCss, props.className)} />;
});
export const NotetakerBanner = ({
  event,
  user,
  isInNotetakerFreeExperiment = false
}) => {
  const dispatch = useDispatch();
  const track = useTrack();
  const {
    notetakerAdded,
    canAdd: canAddNotetaker
  } = useNotetaker();

  // Show banner if notetaker is added, can be added, or user is in experiment
  if (!notetakerAdded && !canAddNotetaker && !isInNotetakerFreeExperiment) return null;
  const isNotPretending = user && !user.is_pretending;
  const showButton = !notetakerAdded && (canAddNotetaker || isInNotetakerFreeExperiment) && isNotPretending;
  const handleExperimentButtonClick = () => {
    track({
      name: TRACKING_EVENT_NAMES.CTA_CLICKED,
      entities: ['attribution', 'organization', 'user'],
      properties: {
        cta_key: 'ai_notetaker_meetings_right_rail_entry_point',
        cta_text: 'try_notetaker_for_free',
        cta_destination: 'ai_notetaker_setup_flow',
        action: AI_NOTETAKER_METERED_ACCESS_STARTED
      }
    });
    dispatch(showAcknowledgementModal(MR_ONBOARDING_WIZARD.USER_TRIGGERED));
  };
  return <Container addNotetaker={!notetakerAdded}>
      <div>
        <HeaderText>
          <AiSparkleIcon spacingRight={8} spacingBottom={4} />
          {notetakerAdded ? I18n.t('publisher.meeting_intelligence.scheduled_event.will_record_header') : I18n.t('publisher.meeting_intelligence.scheduled_event.add_to_meeting_header')}
        </HeaderText>
        <BodyText>
          {notetakerAdded ? I18n.t('publisher.meeting_intelligence.scheduled_event.will_record_body') : I18n.t('publisher.meeting_intelligence.scheduled_event.add_to_meeting_body')}
        </BodyText>
      </div>
      {showButton && (isInNotetakerFreeExperiment && !canAddNotetaker ? <Button size="normal" onClick={handleExperimentButtonClick} aria-label="try-notetaker-button">
            <AiSparkleIcon />
            {I18n.t('publisher.billing.meeting_intelligence.try_notetaker')}
          </Button> : <AddNotetakerButton event={event} buttonLocation={ADD_BUTTON_LOCATION} text={I18n.t('publisher.billing.meeting_intelligence.try_notetaker')} isNotPretending={isNotPretending} />)}
    </Container>;
};

require("./notetaker_banner.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./notetaker_banner.js");